import React from 'react'
import styles from './VideoCard.module.scss'
import Truncate from 'react-truncate'
import Icon, { IconType } from '@bt-react/components/Icon'
import Thumbnail from '@bt-react/components/Thumbnail'
import { VideoCardProps } from './types'
import classnames from 'classnames'
import formatDuration from '@bt-react/libs/formatDuration'

const _ID = 'video-card'

const VideoCard: React.FC<VideoCardProps> = props => {

  function formatLength (seconds: number): string {

    const formatString = formatDuration(seconds)
    const [ time = '', text = '' ] = formatString.split(' ')

    return seconds < 60
      ? `< 1 min`
      : `${time} ${text}`

  }

  const videoCardClasses = classnames(
    styles['VideoCard'], {
      [styles['VideoCard--selected']]: props.selected
    }
  )

  return <div
    className={videoCardClasses}
    data-bdd={props.dataBdd || _ID}
    role='button'
  >
    <div
      className={styles['VideoCard__image-wrapper']}
      onClick={props.onClick}
      data-bdd={`${_ID}-image-wrapper`}
    >
      <Thumbnail
        imgClassName={styles['VideoCard__image']}
        src={props.image}
        alt={props.title}
        data-bdd={`${_ID}-img`}
        ratio="16/9"
      />
      {
        !props.selected && <Icon
          name={IconType.iconName.playShaded}
          colour={IconType.colour.white}
          className={styles[`VideoCard__icon`]}
          dataBdd={`${_ID}-play`}
        />
      }
    </div>

    <p className={styles['VideoCard__title']} data-bdd={`${_ID}-title`}>
      <Truncate lines={3} >
        {props.title}
      </Truncate>
    </p>
    <div className={styles['VideoCard__duration']} data-bdd={`${_ID}-duration`}>
      {formatLength(props.duration)}
    </div>
  </div>

}

export default VideoCard
